import BaseState from "Engine/base/states/BaseState";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import EntryPoint from "Engine/EntryPoint";

export default class IdleState extends BaseState {

    constructor(stateData) {
        super(stateData);
    }

    addListeners() {
        super.addListeners();
        GlobalDispatcher.add('autoPlaySettings:activeChanged', this.onAutoPlayChanged, this);
        GlobalDispatcher.add('autoPlaySettings:pausedChanged', this.onAutoPlayChanged, this);
        //GlobalDispatcher.add('freeBets:started', this.onFreeBetsStarted, this);
    }

    onAutoPlayChanged(event) {
        console.log(event)
        if (this.active && EntryPoint.AutoPlaySettings.active && !EntryPoint.AutoPlaySettings.paused) {
            //EntryPoint.PostMessages && EntryPoint.PostMessages.onAutoPlayStarted()
            this.stop();
        } else {
            //EntryPoint.PostMessages && EntryPoint.PostMessages.onAutoPlayFinished()
        }
    }

    /*onFreeBetsStarted() {
        if (this.active && EntryPoint.GameModel.freeBetsStarted) {
            this.stop();
        }
    }*/

    start() {
        super.start();
        /*if (RgPostMessageAPI) {
            RgPostMessageAPI.gameRoundEnded({balance: EntryPoint.GameModel.balance});
        }*/
        if (!EntryPoint.GameModel.isFreeSpins) {
            GlobalDispatcher.dispatch('request:gamefinished');
        }

        setTimeout(() => {
            if (this.active && (
                    (EntryPoint.AutoPlaySettings.active && !EntryPoint.AutoPlaySettings.paused)
                    || EntryPoint.GameModel.isFreeSpins
                )
            ) {
                this.stop();
            }
        }, 0);
    }

}
